"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";

export default function StickyBanner({ workshop }) {
  const [isVisible, setIsVisible] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    // Show banner after scrolling
    const handleScroll = () => {
      // Show after scrolling 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  // If no workshop data, don't render
  if (!workshop) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-0 left-0 w-full bg-[#fffaf1] border-t border-gray-200 py-4 transition-transform duration-300 z-50 ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="w-[90%] md:w-[80%] mx-auto flex flex-col-reverse gap-2 md:flex-row items-center justify-between">
        <div>
          <h3 className="hidden md:block text-[#002726] text-xl font-medium mb-2 md:mb-0">
            {workshop.sticky}
          </h3>
        </div>

        <div className="flex items-center mt-4 md:mt-0 space-x-3">
          <Link
            href={workshop.payment}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center px-6 py-3 bg-[#33c375] text-black font-medium rounded-lg hover:bg-[#43a047] transition-colors"
          >
            Register Now
          </Link>
        </div>
      </div>
    </div>
  );
}